export { startSegmentCollection, setSegmentBytesLimit } from './segmentCollection';
export { SEGMENT_BYTES_LIMIT } from './segmentCollection';
export { startSegmentTelemetry } from './startSegmentTelemetry';
//# sourceMappingURL=index.js.map